import axios from 'axios'
import router from '../../main'
import store from '../store'

export const set = key => (state, val) => { state[key] = val }
export const started = key => (state, val) => { state['loading'] = true }
export const failed = key => (state, val) => { state['loading'] = false; state['error'] = val }
export const success = key => (state, val) => { state['loading'] = false; state[key] = val }

var adderDismiss = null
console.log(adderDismiss)

function makeUserFailedNotify (state, text) {
  return
  // adderDismiss()
  adderDismiss = Notify.create({
    message: 'Fehler! ' + text,
    position: 'bottom-left'
  })
}

export const setAuthStarted = (state) => {
  state.loading = true
  return
  adderDismiss = Notify.create({
    message: 'Logge dich ein',
    color: 'positive',
    position: 'bottom-left'
    // icon: 'wifi'
  })
}

export const setSuccesfulAuth = (state, data) => {
  console.log(data)
  state.userdata = data.response.signin_user
  state.token = data.response.token
  state.loading = false
  state.username = data.input.username
  state.valid = true
  state.error = null
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token

  store.commit("setOnline");
  store.commit("updateMenue");
  store.commit("setUserData", [state.userdata.firstName, state.userdata.lastName]);
  router.push("/LogInfo");
  store.dispatch("fetchdata");
  // router.push('/')
}

export const setAuthFailed = (state, payload) => {
  console.log(payload)
  state.loading = false
  state.username = null
  state.valid = false
  state.token = null
  state.error = payload.error
  axios.defaults.headers.common['Authorization'] = ''
  // if (typeof payload.error === 'undefined') {
  //   makeUserFailedNotify(state, 'Timeout')
  // } else {
  //   makeUserFailedNotify(state, payload.error.statusText)
  // }
}

export const setSignupStarted = (state) => {
  state.loading = true
  return
  adderDismiss = Notify.create({
    message: 'Registriere dich',
    color: 'positive',
    position: 'bottom-left'
  })
}

export const setSuccesfulSignup = (state, data) => {
  console.log(data)
  store.dispatch("auth/auth", {email: data.input.email, 
    password: data.input.password})
  return;

  
  // adderDismiss = Notify.create({
  //   message: 'Bitte aktiviere deinen Account über deine Email',
  //   color: 'positive',
  //   position: 'bottom-left'
  // })
  state.userdata = data.response.signin_user
  state.token = data.response.token
  state.loading = false
  state.username = data.input.username
  state.valid = true
  state.error = null
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token
  // this.$store.commit("setOnline");
  // this.$store.commit("updateMenue");
  // this.$store.commit("setUserData", [this.firstName, this.lastName]);
  // this.$router.push("/Thanks");
}

export const setSignupFailed = (state, payload) => {
  console.log(payload)
  // makeUserFailedNotify(state, payload.error.statusText)
  state.loading = false
  state.username = null
  state.valid = false
  state.token = null
  state.error = payload.error
  axios.defaults.headers.common['Authorization'] = ''
}

export const setPasswordForgetStarted = (state, payload) => {
  state.loading = true
  return
  adderDismiss = Notify.create({
    message: 'Sende Link an dich',
    color: 'positive',
    position: 'bottom-left'
  })
}

export const setPasswordForgetFailed = (state, payload) => {
  makeUserFailedNotify(state, 'Anfrage fehlgeschlagen')
  state.loading = false
}

export const setSuccesfulPasswordForget = (state, payload) => {
  state.loading = false
  return
  adderDismiss = Notify.create({
    message: 'Erfolgreich gesendet - Sieh in dein Mail Postfach',
    color: 'positive',
    position: 'bottom-left'
  })
}

export const logout = (state) => {
  // localStorage.clear()
  // store.commit('reset')
  window.localStorage.removeItem('vuex')
  state.username = null
  state.loading = false
  state.valid = false
  state.token = null
  state.role = null
  state.id = null
  state.email = null
  state.error = null
  state.userdata = null
  axios.defaults.headers.common['Authorization'] = ''
  // router.push('/login')
}

export const setMe = (state, data) => {
  console.log('me', data)
  state.role = data.role
  state.id = data.id
  state.username = data.name
  state.email = data.email
  store.dispatch('entities/fetchAll')
  router.push('/ueberlassung-list') // TODO: change to overview page
}

export const resetMe = (state) => {
  state.role = null
  state.id = -1
}

export const setPWStarted = (state) => {
  state.pwsetting = true
  state.pwsetfailed = false
}

export const setPWSuccess = (state) => {
  state.pwsetting = false
  return 
  adderDismiss = Notify.create({
    message: 'Passwort erfolgreich gesetzt',
    color: 'positive',
    position: 'bottom-left'
  })
}

export const setPWFailed = (state, response) => {
  console.log(response)
  let text = ''
  if (response.error.data.hasOwnProperty('message')) {
    text = response.error.data.message
  } else {
    text = response.error.statusText
  }

  // adderDismiss = Notify.create({
  //   message: text,
  //   position: 'bottom-left'
  // })
  state.pwsetting = false
  state.pwsetfailed = true
}
